
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import type { BoardPresenceUser } from "@/contexts/BoardPresenceContext";
import { Badge } from "@/components/ui/badge";

interface BoardPresenceAvatarsProps {
  users: BoardPresenceUser[];
  currentUserId: string;
}

export function BoardPresenceAvatars({ users, currentUserId }: BoardPresenceAvatarsProps) {
  const others = users.filter(u => u.user_id !== currentUserId);
  if (others.length === 0) return null;

  const visible = others.slice(0, 3);

  return (
    <div className="flex items-center gap-1">
      <div className="flex -space-x-2">
        {visible.map((user) => (
          <Avatar
            key={user.user_id}
            className="h-7 w-7 border-2 border-white shadow-sm"
            title={user.user_name + (user.role ? ` (${user.role === 'admin' ? 'owner' : user.role})` : "")}
          >
            <AvatarFallback className="bg-primary text-primary-foreground dark:bg-slate-600 dark:text-slate-100 text-xs font-bold">
              {(user.user_name ?? "?").slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        ))}
        {others.length > 3 && (
          <div className="h-7 w-7 rounded-full bg-gray-200 dark:bg-gray-700 border-2 border-white flex items-center justify-center">
            <span className="text-xs text-gray-600 dark:text-gray-400 font-bold">
              +{others.length - 3}
            </span>
          </div>
        )}
      </div>
      <Badge 
        variant="secondary" 
        className="ml-2 text-xs bg-slate-100 text-slate-600"
      >
        {others.length === 1 ? "1 other here" : `${others.length} others here`}
      </Badge>
    </div>
  );
}
